import { useMemo } from "react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { getStoredAuthUser } from "../../utils/backendApi";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "react-image-gallery/styles/css/image-gallery.css";
import dayjs from "dayjs";
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  FormFeedback,
  Form,
  Label,
} from "reactstrap";
import Loader from "../../Components/Common/Loader";
import {
  useQuestion,
  useRespondToQuestion,
  useTakeQuestion,
} from "../../hooks/useQuestions";

// Redux
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const QuestionsAdd = (props) => {
  document.title = "Questions réponse";

  const { id } = useParams();
  const questionQ = useQuestion(id);
  const respondMutation = useRespondToQuestion();
  const takeMutation = useTakeQuestion();

  const question = questionQ.data || null;
  const response = useMemo(() => question?._response || [], [question]);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      response_text: "",
    },

    validationSchema: Yup.object().shape({
      response_text: Yup.string().required("Ce champ est requis"),
    }),
    onSubmit: (values) => {
      const currentUserId = getStoredAuthUser()?.id;
      const takePayload = {
        question_text: question?.question_text,
        taken_by: currentUserId,
      };

      const formData = new FormData();
      formData.append("response_text", values.response_text);

      respondMutation.mutate(
        { id, payload: formData },
        {
          onSuccess: () => {
            takeMutation.mutate({ id, payload: takePayload });
            validation.resetForm();
          },
        }
      );
    },
  });

  if (questionQ.isLoading) {
    return <Loader />;
  }

  if (questionQ.isError) {
    return (
      <Loader
        error={questionQ.error?.message || props.t("Erreur lors du chargement")}
      />
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={props.t("Question réponse")}
          pageTitle={props.t("Questions")}
        />

        <Row className="g-3">
          <Col lg={8}>
            <Card className="shadow-sm border-0">
              <CardBody>
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                  <h5 className="mb-0">{props.t("Question")}</h5>
                  <Badge color={question?.responded ? "success" : "warning"}>
                    {question?.responded ? props.t("Répondu") : props.t("En attente")}
                  </Badge>
                </div>
                <p className="mb-3">{question && question.question_text}</p>
                {question?.question_pic ? (
                  <img
                    src={question.question_pic}
                    className="rounded"
                    style={{ maxWidth: "100%", maxHeight: "320px" }}
                    alt={props.t("Illustration question")}
                  />
                ) : null}
                <div className="text-muted mt-2">
                  {question && dayjs(question.request_date).format("DD-MM-YYYY")}
                </div>
              </CardBody>
            </Card>

            <Card className="shadow-sm border-0 mt-3">
              <CardBody>
                <h5 className="mb-3">{props.t("Historique des réponses")}</h5>
                {response && response.length > 0 ? (
                  response.map((item, key) => (
                    <div key={key} className="border rounded p-3 mb-3">
                      <p className="mb-2">{item.response_text}</p>
                      <div className="text-muted small">
                        {dayjs(item.response_date).format("DD-MM-YYYY")}
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-muted mb-0">{props.t("Aucune réponse pour le moment.")}</p>
                )}
              </CardBody>
            </Card>
          </Col>
          <Col lg={4}>
            <Card className="shadow-sm border-0">
              <CardBody>
                <h5 className="mb-3">{props.t("Répondre à la question")}</h5>
                <Form
                  encType="multipart/form-data"
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                  }}
                >
                  <div className="mb-3">
                    <textarea
                      className={`form-control ${
                        validation.errors.response_text &&
                        validation.touched.response_text
                          ? "is-invalid"
                          : ""
                      }`}
                      name="response_text"
                      value={validation.values.response_text}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      rows="2"
                      cols="20"
                    />
                    {validation.errors.response_text &&
                    validation.touched.response_text ? (
                      <FormFeedback type="invalid">
                        {props.t(validation.errors.response_text)}
                      </FormFeedback>
                    ) : null}
                  </div>
                  <div className="text-end mb-3">
                    <Link to="/questions-answers" className="btn btn-primary me-2">
                  {props.t("Retour")}
                </Link>
                    <button
                      type="submit"
                      className="btn btn-warning m-2"
                      disabled={
                        respondMutation.isPending || takeMutation.isPending
                      }
                    >
                      {props.t("Envoyer")}
                    </button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
QuestionsAdd.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(QuestionsAdd));
